module.exports = "function LocalizedUserBadge () {\n  return (\n    <WithLocalization>\n      {(localization) => (\n        <WithUser>\n          {(user) => (\n            <h1>\n              {localization.get('user_greeting', { name: user.name })}\n            </h1>\n          )}\n        </WithUser>\n      )}\n    </WithLocalization>\n  )\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/function-children-example-3.js
 ** module id = 284
 ** module chunks = 0
 **/